import '../style/Home.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container } from 'react-bootstrap';
import React from 'react';
import StudyProfile from './StudyProfile';
import StudyFeedback from './StudyFeedback';
import SimulationMovieUpload from './SimulationMovieUpload';



const ResultsStudy = ( { study, user }) => {
    
    console.log('Load study page');

    return (
        <Container className="container">
            <Tabs
                defaultActiveKey={"study-profile"+study.studyName}
                id="study-results-tabs"
                className="mb-5"
                variant='tabs'
            >
                <Tab key={'overview'+study.studyName} eventKey={"study-profile"+study.studyName} title="Overview">
                    <StudyProfile study={study} user={user}></StudyProfile>
                </Tab>
                <Tab key={'feedback'+study.studyName} eventKey={"study-feedback"+study.studyName} title="Feedback">
                    <StudyFeedback study={study} user={user}></StudyFeedback>
                </Tab>
                <Tab key={'movieupload'+study.studyName} eventKey={"study-movieupload"+study.studyName} title="Movie Uploads">
                    <SimulationMovieUpload study={study} user={user}></SimulationMovieUpload>
                </Tab>

            </Tabs>
        </Container>
    );
}

export default ResultsStudy;